import React from "react"
import { makeStyles } from '@material-ui/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    table: {
        // minWidth: 650,
    },
});

function createData(name, calories, fat, carbs, protein, protein2, protein3, protein4) {
    return { name, calories, fat, carbs, protein, protein2, protein3, protein4 };
}

const rows = [
    createData("Հոսքագիծ N1", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
    createData("Հոսքագիծ N2", "CN", 1403500365, 9596961, 146.24, 146.24, 146.24, 146.24),
    createData("Հոսքագիծ N3", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
    createData("Հոսքագիծ N4", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
    createData("Հոսքագիծ N5", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
    createData("Հոսքագիծ N6", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
    createData("Հոսքագիծ N7", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
    createData("Հոսքագիծ N", "IN", 1324171354, 3287263, 402.82, 402.82, 402.82, 402.82),
];




const TableExample = (props) => {
    const { className } = props
    const classes = useStyles();
    return (
        <TableContainer component={Paper} className={className}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow >
                        <TableCell className="table1Cell">Ըստ հոսքագծերի</TableCell>
                        <TableCell align="right" className="table1Cell">Պլան</TableCell>
                        <TableCell align="right" className="table1Cell">Արտադրված</TableCell>
                        <TableCell align="right" className="table1Cell">Կատարողական</TableCell>
                        <TableCell align="right" className="table1Cell">Վերաուղղված</TableCell>
                        <TableCell align="right" className="table1Cell">Վերաուղղման %</TableCell>
                        <TableCell align="right" className="table1Cell">Պահեստ</TableCell>
                        <TableCell align="right" className="table1Cell">Disbalance</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.name}  >
                            <TableCell scope="row" className="table1Cell">
                                {row.name}
                            </TableCell>
                            <TableCell align="right" className="table1Cell">{row.calories}</TableCell>
                            <TableCell align="right" className="table1Cell">{row.fat}</TableCell>
                            <TableCell align="right" className="table1Cell">{row.carbs}</TableCell>
                            <TableCell align="right" className="table1Cell">{row.protein}</TableCell>
                            <TableCell align="right" className="table1Cell">{row.protein2}</TableCell>
                            <TableCell align="right" className="table1Cell">{row.protein3}</TableCell>
                            <TableCell align="right" className="table1Cell">{row.protein4}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default TableExample